var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\r\n<p>Please select applicable D/B/As</p>\r\n<form class=\"dba-form form-horizontal\">\r\n  <div class=\"dbas\"></div>\r\n</form>";
},"useData":true});